import { render } from "./UserUpdatePage.vue?vue&type=template&id=4d3c418c&ts=true"
import script from "./UserUpdatePage.vue?vue&type=script&lang=ts"
export * from "./UserUpdatePage.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/KhamSucKhoe_NewVersion/KhamSucKhoe_FE_newVersion/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__